import NavPublicUser from "../navbarPublicUser";
import Footer from "../Footer";
import CategoryPubBody from "../CategoryPubBody";
export default function PubCategory(){

    return(
        <div>
            <NavPublicUser />
          <div data-aos="fade-up" data-aos-delay="0">
            <CategoryPubBody />
          </div>
            
            <Footer />

        </div>

    )




}